export default __webpack_public_path__ + "static/media/videocam-off(white).264d61d4.svg";